// An item's current when the state service holds none
// (02-DESIGN/10-state/01-stores-types-and-instances.md § the console: Stores;
// issue 191). An untyped trail of operations of effect none — the
// observability solution's day of records — has a history and no folded
// state, and the service's get answers it not-found by design
// (02-the-state-service.md § reads). That is not a failure: the item's page says it has no
// current state and is the record of the changes below it. Only a path with
// no changes either is no item.

/** NoCurrent is how an item with no current state reads, or "reading" while its history is still being read. */
export type NoCurrent = "trail" | "absent" | "unknown" | "reading";

/**
 * noCurrent reads a get the service answered not-found beside the item's
 * history: the count of its changes, undefined while the history is being
 * read, null when the history could not be read. A get refused for any
 * other reason is a failure and shown as one, so it answers undefined.
 */
export function noCurrent(notFound: boolean, changes: number | null | undefined): NoCurrent | undefined {
  if (!notFound) {
    return undefined;
  }
  if (changes === undefined) {
    return "reading";
  }
  if (changes === null) {
    return "unknown";
  }
  return changes > 0 ? "trail" : "absent";
}

/** NO_CURRENT_WORDS are the one muted sentence the current says in each case. */
export const NO_CURRENT_WORDS: Readonly<Record<Exclude<NoCurrent, "reading">, string>> = {
  trail: "No current state. This item is a record of the changes below; none of them sets a state.",
  absent: "No item here: nothing has been written at this path.",
  unknown: "No current state.",
};
